import Images from "../utils/Images";

const navbarLinks = [
  { id: "home", title: "Home" },
  { id: "about", title: "About Us", href: "/about" },
  { id: "faqs", title: "FAQs", href: "/faqs" },
  { id: "contact", title: "Contact Us" },
];

const RESOURCES = [
  {
    id: "legal",
    name: "Legal",
    href: "/legal",
    description: "Terms and site policies",
  },
  {
    id: "privacy",
    name: "Privacy Policy",
    href: "/privacy",
    description: "How we protect your data",
  },
  {
    id: "newsletter",
    name: "Newsletter",
    href: "/#newsletter",
    description: "Product and market updates",
  },
];

const REGIONS = [
  {
    id: "ghana",
    name: "Ghana",
    description: "Local market",
  },
  {
    id: "global",
    name: "Global",
    description: "International market",
  },
];

const SERVICES = [
  {
    id: "simmarket",
    name: "SimMarket",
    menuLabel: "Financial Marketplace Platform",
    href: "/simmarkets",
    logo: Images.simmarket_logo,
    visual: "market",
    index: "01",
    description: "Financial Marketplace & Customer Acquisition",
    detail: "Connect customers with the right financial products through a trusted marketplace.",
    spec: [
      { label: "Focus", value: "Marketplace matching" },
      { label: "Outcome", value: "Customer acquisition" },
    ],
  },
  {
    id: "simverify",
    name: "SimVerify",
    menuLabel: "Trust & Verifications Platform",
    href: "/simverify",
    logo: Images.simverify_logo,
    visual: "verify",
    index: "02",
    description: "AI Digital Trust & Verification",
    detail: "Confirm identity and integrity with AI-backed digital trust checks.",
    spec: [
      { label: "Focus", value: "Identity assurance" },
      { label: "Outcome", value: "Digital trust" },
    ],
  },
  {
    id: "simcollect",
    name: "SimCollect",
    menuLabel: "Recovery & Collections Platform",
    href: "/simcollect",
    logo: Images.simcollect_logo,
    visual: "collect",
    index: "03",
    description: "Intelligent Debt Recovery & Collections",
    detail: "Recover outstanding balances with intelligent, compliant collections workflows.",
    spec: [
      { label: "Focus", value: "Intelligent recovery" },
      { label: "Outcome", value: "Compliant collections" },
    ],
  },
];

export { navbarLinks, SERVICES, RESOURCES, REGIONS };
